import type {ValueEditorLocalizationManagerProvider} from './localizations/value-editor-localization-manager.provider';
import type {ErrorMessagesLocalizationService} from './internal/errors/error-messages-localization.service';
import type {LocalizationService} from '../providers/localization.provider';

/*@ngInject*/
export function valueEditorsLocalizationsConfig(
    localizationService: LocalizationService,
    valueEditorLocalizationManagerProvider: ValueEditorLocalizationManagerProvider,
    errorMessagesLocalizationService: ErrorMessagesLocalizationService) {

    valueEditorLocalizationManagerProvider.getManagerForType('acceptable-root').setAll({
        cannotSelect: `(${localizationService.get(/* @kp-localization commons.nelzeVybrat */ 'commons.nelzeVybrat')})`,
        showAll: localizationService.get(/* @kp-localization commons.ZobrazitVse */ 'commons.ZobrazitVse'),
        deselectAll: localizationService.get(/* @kp-localization commons.OdznacitVse */ 'commons.OdznacitVse'),
        selectAll: localizationService.get(/* @kp-localization commons.VybratVse */ 'commons.VybratVse'),
        expandNode: localizationService.get(/* @kp-localization commons.Expand */ 'commons.Expand'),
        collapseNode: localizationService.get(/* @kp-localization commons.Collapse */ 'commons.Collapse')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('single-acceptable').setAll({
        noneOfTheOptions: localizationService.get(/* @kp-localization commons.NoneOfTheOptions */ 'commons.NoneOfTheOptions')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('multiple-acceptable').setAll({
        changeToCheckboxesMsg: localizationService.get(/* @kp-localization accessibility.ChangeToCheckboxesMessage */ 'accessibility.ChangeToCheckboxesMessage'),
        deselectOption: localizationService.get(/* @kp-localization commons.Unselect */ 'commons.Unselect'),
        moveDown: localizationService.get(/* @kp-localization commons.MoveDown */ 'commons.MoveDown'),
        moveUp: localizationService.get(/* @kp-localization commons.MoveUp */ 'commons.MoveUp'),
        allSelected: localizationService.get(/* @kp-localization commons.AllSelected */ 'commons.AllSelected'),
        more: localizationService.get(/* @kp-localization commons.more */ 'commons.more'),
        less: localizationService.get(/* @kp-localization commons.less */ 'commons.less'),
        selectAll: localizationService.get(/* @kp-localization commons.VybratVse */ 'commons.VybratVse'),
        deselectAll: localizationService.get(/* @kp-localization commons.OdznacitVse */ 'commons.OdznacitVse')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('text-or-select').setAll({
        select: localizationService.get(/* @kp-localization commons.SelectEllipsis */ 'commons.SelectEllipsis'),
        orType: localizationService.get(/* @kp-localization commons.orTypeEllipsis */ 'commons.orTypeEllipsis'),
        selectOptionOrTypeManually: localizationService.get(/* @kp-localization accessibility.selectOptionOrTypeManually */ 'accessibility.selectOptionOrTypeManually'),
        suggestedOptions: localizationService.get(/* @kp-localization accessibility.suggestedOptions */ 'accessibility.suggestedOptions')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('generable-text').setAll({
        generationError: localizationService.get(/* @kp-localization commons.OperationEndedWithError */ 'commons.OperationEndedWithError'),
        generate: localizationService.get(/* @kp-localization editace.Vygenerovat */ 'editace.Vygenerovat')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('list').setAll({
        required: localizationService.get(/* @kp-localization commons.required */ 'commons.required'),
        add: localizationService.get(/* @kp-localization commons.Pridat */ 'commons.Pridat'),
        remove: localizationService.get(/* @kp-localization commons.odebrat */ 'commons.odebrat'),
        item: localizationService.get(/* @kp-localization commons.item */ 'commons.item')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('object').setAll({
        hint: localizationService.get(/* @kp-localization commons.napoveda */ 'commons.napoveda'),
        required: localizationService.get(/* @kp-localization commons.required */ 'commons.required')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('number-range').setAll({
        from: localizationService.get(/* @kp-localization commons.From */ 'commons.From'),
        to: localizationService.get(/* @kp-localization commons.to */ 'commons.to')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('range').setAll({
        from: localizationService.get(/* @kp-localization commons.From */ 'commons.From'),
        to: localizationService.get(/* @kp-localization commons.to */ 'commons.to')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('password').setAll({
        confirmPassword: localizationService.get(/* @kp-localization commons.ConfirmPassword */ 'commons.ConfirmPassword'),
        noChangeIfEmpty: localizationService.get(/* @kp-localization commons.EmptyPasswordForNoChange */ 'commons.EmptyPasswordForNoChange')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('scannable-text').setAll({
        scanWithCamera: localizationService.get(/* @kp-localization commons.ScanWithCamera */ 'commons.ScanWithCamera'),
        stopScanning: localizationService.get(/* @kp-localization commons.StopScanning */ 'commons.StopScanning')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('text-with-metadata').setAll({
        startsWith: localizationService.get(/* @kp-localization hledani.zacinaNa */ 'hledani.zacinaNa'),
        wholeStartsWith: localizationService.get(/* @kp-localization hledani.zacinaNaPole */ 'hledani.zacinaNaPole'),
        equals: localizationService.get(/* @kp-localization hledani.exactMatch */ 'hledani.exactMatch'),
        equalsWords: localizationService.get(/* @kp-localization hledani.equalsWords */ 'hledani.equalsWords'),
        currentSelectValue: localizationService.get(/* @kp-localization commons.SelectedValue */ 'commons.SelectedValue'),
        metadataSelectLabel: '', // this text depends on context (what can user choose)
        mainInputLabel: '' // this text depends on context (what should user input)
    });

    valueEditorLocalizationManagerProvider.getManagerForType('search-or-edit').setAll({
        search: localizationService.get(/* @kp-localization commons.Find */ 'commons.Find'),
        searchOther: localizationService.get(/* @kp-localization commons.FindOther */ 'commons.FindOther'),
        editValue: localizationService.get(/* @kp-localization editace.CorrectValue */ 'editace.CorrectValue'),
        createNew: localizationService.get(/* @kp-localization record.editation.CreateNew */ 'record.editation.CreateNew'),
        delete: localizationService.get(/* @kp-localization commons.Smazat */ 'commons.Smazat')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('autocomplete').setAll({
        showOptions: localizationService.get(/* @kp-localization commons.ShowAutosuggestOptions */ 'commons.ShowAutosuggestOptions')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('date').setAll({
        openCalendar: localizationService.get(/* @kp-localization accessibility.OpenCalendarMsg */ 'accessibility.OpenCalendarMsg'),
        timeView: localizationService.get(/* @kp-localization accessibility.ShowTimeView */ 'accessibility.ShowTimeView'),
        backToDate: localizationService.get(/* @kp-localization accessibility.BackToDateView */ 'accessibility.BackToDateView'),
        todayBtn: localizationService.get(/* @kp-localization commons.Dnes */ 'commons.Dnes'),
        clearBtn: localizationService.get(/* @kp-localization commons.Smazat */ 'commons.Smazat')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('price').setAll({
        currentSelectValue: localizationService.get(/* @kp-localization commons.SelectedValue */ 'commons.SelectedValue'),
        currencySelectLabel: /* @kp-localization commons.accessibility.ChooseCurrency */ 'commons.accessibility.ChooseCurrency',
        amountInputLabel: /* @kp-localization commons.accessibility.EnterAmount */ 'commons.accessibility.EnterAmount'
    });

    valueEditorLocalizationManagerProvider.getManagerForType('telephone-number').setAll({
        forSmsMessages: localizationService.get(/* @kp-localization sms.ForSmsMessages */ 'sms.ForSmsMessages'),
        forSmsOnly: localizationService.get(/* @kp-localization sms.ForSmsOnly */ 'sms.ForSmsOnly')
    });

    errorMessagesLocalizationService.setAll({
        required: localizationService.get(/* @kp-localization validation.ThisFieldIsRequired */ 'validation.ThisFieldIsRequired'),
        async: localizationService.get(/* @kp-localization validation.UnknownError */ 'validation.UnknownError'),
        minlength: localizationService.get(/* @kp-localization validation.TooShort */ 'validation.TooShort'),
        maxlength: localizationService.get(/* @kp-localization validation.TooLong */ 'validation.TooLong'),
        pattern: localizationService.get(/* @kp-localization validation.WrongFormat */ 'validation.WrongFormat'),
        // eslint-disable-next-line id-blacklist
        number: localizationService.get(/* @kp-localization validation.WrongNumber */ 'validation.WrongNumber'),
        date: localizationService.get(/* @kp-localization validation.WrongFormatOfDate */ 'validation.WrongFormatOfDate'),
        min: localizationService.get(/* @kp-localization validation.NumberIsTooLow */ 'validation.NumberIsTooLow'),
        max: localizationService.get(/* @kp-localization validation.NumberIsTooHigh */ 'validation.NumberIsTooHigh'),
        fromBiggerThanTo: localizationService.get(/* @kp-localization validation.FromIsHigherThanTo */ 'validation.FromIsHigherThanTo'),
        toBiggerThanFrom: localizationService.get(/* @kp-localization validation.ToIsHigherThanFrom */ 'validation.ToIsHigherThanFrom'),
        minDate: localizationService.get(/* @kp-localization validation.DateIsTooLow */ 'validation.DateIsTooLow'),
        maxDate: localizationService.get(/* @kp-localization validation.DateIsTooHigh */ 'validation.DateIsTooHigh'),
        'list-required': localizationService.get(/* @kp-localization validation.ListCannotBeEmpty */ 'validation.ListCannotBeEmpty'),
        'max-count': localizationService.get(/* @kp-localization validation.TooManyItems */ 'validation.TooManyItems'),
        'passwords-equals': localizationService.get(/* @kp-localization validation.PasswordsDoNotMatch */ 'validation.PasswordsDoNotMatch'),
        email: localizationService.get(/* @kp-localization validation.WrongEmail */ 'validation.WrongEmail'),
        url: localizationService.get(/* @kp-localization validation.WrongUrl */ 'validation.WrongUrl'),
        notBlank: localizationService.get(/* @kp-localization validation.BlankInput */ 'validation.BlankInput')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('inline-record-search').setAll({
        delete: localizationService.get(/* @kp-localization commons.Smazat */ 'commons.Smazat')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('date-range').setAll({
        openRangeSelector: localizationService.get(/* @kp-localization commons.OpenDateRangeSelector */ 'commons.OpenDateRangeSelector'),
        selectedRange: localizationService.get(/* @kp-localization commons.SelectedDateRange */ 'commons.SelectedDateRange'),
        from: localizationService.get(/* @kp-localization commons.from */ 'commons.from'),
        to: localizationService.get(/* @kp-localization commons.to */ 'commons.to')
    });

    valueEditorLocalizationManagerProvider.getManagerForType('markdown').setAll({
        emptyValue: localizationService.get(/* @kp-localization richTextArea.editor.emptyValuePlaceholder */ 'richTextArea.editor.emptyValuePlaceholder'),
        editValue: localizationService.get(/* @kp-localization richTextArea.editor.editButtonLabel */ 'richTextArea.editor.editButtonLabel')
    });
}